<template>
  <div class="match">
    <div class="box">
      <div class="color result">RESULTATS</div>
      <router-link v-bind:to="link(match)" class="event" v-for="match in events" :title="title(match)" v-bind:key="match.event">
        <div><v-img :src="match.logo1"/></div>
        <span :class="match.styl1">{{match.eq1}}</span>
        <span class="score">{{match.score1}} - {{match.score2}}</span>
        <span :class="match.styl2">{{match.eq2}}</span>
        <div><v-img :src="match.logo2"/></div>
      </router-link>
    </div>
    <div class="box">
    <div class="color result">PROCHAINS MATCHS</div>
    <div v-for="date in next_events"  v-bind:key="date.date">
      <span class="date">{{date[0].dateInfo.label}}</span>
      <router-link v-bind:to="link(match)" class="event" v-for="match in date" :title="title(match)" v-bind:key="match.event">
        <div><v-img :src="match.logo1"/></div>
        <span :class="match.styl1">{{match.eq1}}</span>
        <span class="score">{{match.dateInfo.hour}}</span>
        <span :class="match.styl2">{{match.eq2}}</span>
        <div><v-img :src="match.logo2"/></div>
      </router-link>
    </div>
    </div>  
  </div>
</template>

<script>

  const Promise = require('bluebird');
  import EventService from '../../services/event.service'
  import TeamService from '../../services/team.service'

  export default {
    name: 'Match',
    props: {},
    created() {
      return Promise.resolve(TeamService.getTeams())
        .then(() => EventService.getAgenda())
        .map(this.bindTeam)
        .then(results => _.sortBy(results, r => _.get(r, "dateInfo.order")))
        .then(results => this.next_events = _.groupBy(results, "date"))
        .then(() => EventService.getClubResults())
        .map(this.bindTeam)
        .then(results => this.events = _.sortBy(results, "team"))
    },
    methods: {
      link(match) {
        return "/teams/" + match.team
      },
      title(match) {
        return `${match.event} \r\n ${match.eq1}     ${match.score1}-${match.score2}     ${match.eq2}`; 
      },
      bindTeam(r) {
        r.team = TeamService.teamByEvent(r.competition, r)
        if (_.isEmpty(r.team)) {
          console.error(r.competition + " not found !")
          //debugger;
        } else {
          r.team = r.team.replace(/f-2/, 'F 2')
          r.team = r.team.replace(/u-/, 'U')
          r.team = r.team.replace(/1-/, '1')
          r.team = r.team.replace(/-/, ' ')
          r.team = _.toUpper(r.team)
          r.eq1 = r.eq1.replace('ASSPM', r.team)
          r.eq2 = r.eq2.replace('ASSPM', r.team)
        }
        return r
      },
    },
    data() {
      return {
        events: [],
        next_events: []
      }
    }
  }

</script>

<style scoped lang="stylus">
  .match
    a
      color black
    img
      width 20px
      height 20px
    white-space nowrap
    .box
      padding 5px
    .event
      border-bottom: 1px solid #e5e5e5;
      display flex
      span
        flex 2
        text-overflow ellipsis
        overflow hidden
        text-align center
        &.score
          flex 1
    .result
      display block
      text-align center
      font-weight bold
    .date
      display block
      text-align center
      text-transform uppercase
      font-weight bold   
</style>
